export default (str) => {
    const idx = str.lastIndexOf('.')
    if (idx === -1) {
        return str;
    }
    return str.slice(idx + 1)
}
